/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
import { NamedNode } from '../models.js';
import { Prefix } from '../utils/Prefix.js';
import { createNameSpace } from '../utils/NameSpace.js';
var base = 'http://www.w3.org/ns/shacl#';
export var _ontologyResource = NamedNode.getOrCreate(base);
Prefix.add('shacl', base);
export var ns = createNameSpace('http://www.w3.org/ns/shacl#');
//add your ontology nodes here
var _class = ns('class');
var datatype = ns('datatype');
var declare = ns('declare');
var _in = ns('in');
var maxCount = ns('maxCount');
var minCount = ns('minCount');
var inList = ns('inList');
var name = ns('name');
var description = ns('description');
var NodeShape = ns('NodeShape');
var optional = ns('optional');
var Parameter = ns('Parameter');
var PrefixDeclaration = NamedNode.getOrCreate(base + 'PrefixDeclaration');
var path = ns('path');
var property = ns('property');
var prefix = ns('prefix');
var PropertyShape = ns('PropertyShape');
var targetClass = ns('targetClass');
var targetNode = ns('targetNode');
var node = ns('node');
var nodeKind = ns('nodeKind');
var Shape = ns('Shape');
var BlankNode = ns('BlankNode');
var IRI = ns('IRI');
var Literal = ns('Literal');
var BlankNodeOrIRI = ns('BlankNodeOrIRI');
var BlankNodeOrLiteral = NamedNode.getOrCreate(base + 'BlankNodeOrLiteral');
var IRIOrLiteral = ns('IRIOrLiteral');
export var languageIn = ns('languageIn');
export var lessThan = ns('lessThan');
export var lessThanOrEquals = ns('lessThanOrEquals');
export var maxExclusive = ns('maxExclusive');
export var maxInclusive = ns('maxInclusive');
export var maxLength = ns('maxLength');
export var minExclusive = ns('minExclusive');
export var minInclusive = ns('minInclusive');
export var minLength = ns('minLength');
export var pattern = ns('pattern');
export var uniqueLang = ns('uniqueLang');
export var ValidationReport = ns('ValidationReport');
export var conforms = ns('conforms');
export var ValidationResult = ns('ValidationResult');
export var focusNode = ns('focusNode');
export var sourceShape = ns('sourceShape');
export var resultSeverity = ns('resultSeverity');
export var resultPath = ns('resultPath');
export var value = ns('value');
export var message = ns('message');
export var Violation = ns('Violation');
export var AbstractResult = ns('AbstractResult');
export var sourceConstraintComponent = ns('sourceConstraintComponent');
export var ClassConstraintComponent = ns('ClassConstraintComponent');
export var NodeConstraintComponent = ns('NodeConstraintComponent');
export var DatatypeConstraintComponent = ns('DatatypeConstraintComponent');
export var MinLengthConstraintComponent = ns('MinLengthConstraintComponent');
export var MaxLengthConstraintComponent = ns('MaxLengthConstraintComponent');
export var result = ns('result');
//make sure every node is also exported here
export const shacl = {
    class: _class,
    datatype,
    declare,
    in: _in,
    maxCount,
    minCount,
    name,
    description,
    node,
    NodeShape,
    optional,
    Parameter,
    PrefixDeclaration,
    path,
    prefix,
    property,
    PropertyShape,
    Shape,
    targetClass,
    targetNode,
    BlankNode,
    IRI,
    Literal,
    BlankNodeOrIRI,
    BlankNodeOrLiteral,
    IRIOrLiteral,
    nodeKind,
    inList,
    languageIn,
    lessThan,
    lessThanOrEquals,
    maxExclusive,
    maxInclusive,
    maxLength,
    minExclusive,
    minInclusive,
    minLength,
    pattern,
    uniqueLang,
    ValidationReport,
    conforms,
    ValidationResult,
    focusNode,
    sourceShape,
    resultSeverity,
    resultPath,
    value,
    message,
    Violation,
    sourceConstraintComponent,
    ClassConstraintComponent,
    NodeConstraintComponent,
    DatatypeConstraintComponent,
    MinLengthConstraintComponent,
    MaxLengthConstraintComponent,
    AbstractResult,
    result,
};
//# sourceMappingURL=shacl.js.map